import {IBooster, ITeam} from "modules/actions/team";
import {FantasyTileStatus, FantasyTileType} from "modules/enums";
import {createAction} from "redux-act";

export interface IFantasyTeam extends ITeam {
	event_points: number | null;
	tiles: {id: number}[];
	boosters: IBooster[];
}

export interface ILandingLink {
	title: string;
	link: string;
}

export interface ILandingSettings {
	mainPageHeaderTitle: string;
	mainPageHeaderBody: string;
	mainPageHeaderLink1: ILandingLink;
	mainPageHeaderLink2: ILandingLink;
}

export interface IFantasyTileEvent {
	id: number;
}

export interface IFantasyTile {
	id: number;
	swingId: number | null;
	name: string;
	color: string | null;
	textColor: string | null;
	backgroundImage: string | null;
	logo: string | null;
	courseImage: string | null;
	type: FantasyTileType;
	status: FantasyTileStatus;
	isActive: boolean;
	events: IFantasyTileEvent[];
	startDate: string | null;
	endDate: string | null;
	nextEvent: IFantasyTileEvent | null;
}

export const fetchLandingTiles = createAction();
export const fetchLandingTilesSuccess = createAction<IFantasyTile[]>();
export const fetchLandingTilesError = createAction();

export const fetchFullTeam = createAction();
export const fetchFullTeamSuccess = createAction<IFantasyTeam>();
export const fetchFullTeamError = createAction();

export const joinTileRequest = createAction<number>();
export const selectTile = createAction<number | null>();

export const fetchLandingSettings = createAction();
export const fetchLandingSettingsSuccess = createAction<ILandingSettings>();
export const fetchLandingSettingsError = createAction();

export const updateStatusFilter = createAction<string[]>();
export const toggleFilter = createAction<boolean>();
